class DrvExperts extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.drv-experts__track');
    this.cards = [...this.querySelectorAll('.drv-expert')];
    if (!this.cards.length) return;
    const n = this.cards.length;

    if (n > 1) {
      const pre = this.cards[n - 1].cloneNode(true);
      const post = this.cards[0].cloneNode(true);
      for (const c of [pre, post]) {
        c.classList.remove('is-active');
        c.classList.add('drv-expert--clone');
        c.setAttribute('aria-hidden', 'true');
      }
      this.track.insertBefore(pre, this.cards[0]);
      this.track.appendChild(post);
    }

    const barLabel = this.dataset.barLabel || '';
    const barsWrap = this.querySelector('.drv-experts__bars');
    this.bars = this.cards.map((c, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'drv-experts__bar';
      if (barLabel) b.setAttribute('aria-label', barLabel.replace('[index]', String(i + 1)));
      b.addEventListener('click', () => this.user(i));
      barsWrap.appendChild(b);
      return b;
    });

    const thumbsWrap = this.querySelector('.drv-experts__thumbs');
    this.thumbs = this.cards.map((c, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'drv-experts__thumb';
      if (barLabel) b.setAttribute('aria-label', barLabel.replace('[index]', String(i + 1)));
      const img = c.querySelector('.drv-expert__media img');
      if (img) {
        const t = img.cloneNode();
        t.removeAttribute('class');
        t.sizes = '56px';
        b.appendChild(t);
      }
      b.addEventListener('click', () => this.user(i));
      thumbsWrap.appendChild(b);
      return b;
    });
    thumbsWrap.hidden = false;

    this.querySelector('[data-prev]').addEventListener('click', () => this.user((this.index - 1 + n) % n));
    this.querySelector('[data-next]').addEventListener('click', () => this.user((this.index + 1) % n));

    window.addEventListener('resize', () => { this.place(); this.position(); });
    this.addEventListener('pointerenter', () => this.stop());
    this.addEventListener('pointerleave', () => this.start());

    const vp = this.querySelector('.drv-experts__viewport') || this;
    if (window.DrvDrag) {
      window.DrvDrag.swipe(vp, () => this.user((this.index - 1 + n) % n), () => this.user((this.index + 1) % n));
    }

    this.set(0);
    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  start() {
    const delay = (parseInt(this.dataset.autoplay, 10) || 0) * 1000;
    if (!delay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.stop();
    this.timer = setInterval(() => this.set((this.index + 1) % this.cards.length), delay);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }

  user(i) {
    this.set(i);
    this.start();
  }

  set(i) {
    this.index = i;
    this.cards.forEach((c, j) => c.classList.toggle('is-active', j === i));
    this.bars.forEach((b, j) => b.classList.toggle('is-active', j === i));
    this.thumbs.forEach((t, j) => t.classList.toggle('is-active', j === i));
    this.place();
    this.position();
  }

  place() {
    const thumbs = this.querySelector('.drv-experts__thumbs');
    const footer = this.querySelector('.drv-experts__footer');
    if (!window.matchMedia('(min-width: 750px)').matches) {
      const active = this.cards[this.index];
      active.insertBefore(thumbs, active.querySelector('.drv-expert__content'));
      if (footer) active.appendChild(footer);
    } else {
      this.insertBefore(thumbs, this.querySelector('.drv-experts__controls'));
      if (footer) this.appendChild(footer);
    }
  }

  position() {
    if (!window.matchMedia('(min-width: 750px)').matches) {
      this.track.style.transform = '';
      return;
    }
    const card = this.cards[this.index];
    const viewport = this.querySelector('.drv-experts__viewport');
    const tx = viewport.clientWidth / 2 - (card.offsetLeft + card.offsetWidth / 2);
    this.track.style.transform = `translateX(${tx}px)`;
  }
}

if (!customElements.get('drv-experts')) {
  customElements.define('drv-experts', DrvExperts);
}
